/* eslint-disable no-unused-vars */

import { html, PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-upload-image-confirmation-modal.html";

/**
 * @customElement
 * @polymer
 */
export class NsUploadImageConfirmationModal extends PolymerElement {
  constructor() {
    super();
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get is() {
    return "ns-upload-image-confirmation-modal";
  }

  ready() {
    super.ready();

    this.toggle = () => {
      this.$.removeImage.toggle();
    };

    this.parentComponent = this.parentNode.host;
  }

  _cancelImageRemoval() {
    this.parentComponent._cancelImageRemoval();
  }

  _removeImage() {
    this.parentComponent._removeImage();
  }
}

window.customElements.define(
  NsUploadImageConfirmationModal.is,
  NsUploadImageConfirmationModal
);
